module.exports = __webpack_public_path__ + "img/brand-logo-colored.53d0e54f.png";